import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { Subject, Subscription } from 'rxjs';
import { UsersService } from '../../services/users.service';
import { UserCreateComponent } from '../user-create/user-create.component';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { filter, takeUntil } from 'rxjs/operators';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { UserNotifyComponent } from 'src/app/shared/user-notify/user-notify.component';
import { videoAssetGroups } from '@configs/videoTitles';


export interface userEditUuid {
  useruuid: number;
}


@Component({
  selector: 'app-user-landing',
  templateUrl: './user-landing.component.html',
  styleUrls: ['./user-landing.component.scss']
})


export class UserLandingComponent {
  clientId: number;
  userServiceSubscription$: Subscription | undefined;
  userFilterServiceSubscription$: Subscription | undefined;
  tests: any;
  displayedColumns: string[] = ['firstName',
    'lastName',
    'emailId',
    'roles',
    'status',
    'updated'
  ];
  totalRecords: any;
  searchText: any;
  page: number = 1;
  itemName = "";

  usersData: any;
  firstName = "";
  lastName = "";
  emailId = "";
  userStatus = "";

  testName = "";
  itemDescription = "";
  testDescription = "";
  tagdescription = "";
  itemStatus = "";
  testStatus = "";
  isItemDescended = true;
  itemId = 10;
  public config: any = {
    id: 'custom',
    itemsPerPage: 3,
    currentPage: 1
  };

  userfirstName = "";
  userlastName = "";
  userActiveStatus = "";

  pageOfItems: any;
  noDataFound = false;
  testStatusList: any;
  isNoUser = false;
  routeSubscription: Subscription;

  // @ViewChild(MatSort) set content(sort: MatSort) {
  //   this.usersData.sort = sort;
  // }
  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if(this.usersData){
      this.usersData.paginator = paginator;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  private unsubscribe: Subject<void> = new Subject<void>();
  statusList: any;
  userCount : any;
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(
    private testService: TestService,
    private router: Router,
    private usersService: UsersService,
    public dialog: MatDialog,
    private webErrorService: WebErrorService,
    public roleSer: RoleManagementService,
    public translate: TranslateService,
    private routerstate: ActivatedRoute,
  ) {
    this.usersService.getStatusList().subscribe((statusList) => { this.statusList = statusList.data;})

    this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((data: NavigationEnd) => { if (data.url == "/users") { this.getUserLandingData() } });
  }

  onTraningIcon(assetGroup) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.usersService.videoTutorial(assetGroup).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  getUserLandingData() {
    this.userServiceSubscription$ = this.usersService.getNewData.subscribe(resData => {
      this.usersData = resData?.data;
      if (this.usersData?.length == 0 || this.usersData == undefined) {
        this.isNoUser = true;
      }
      else {
        this.usersData = new MatTableDataSource(this.usersData);
        this.userCount = this.usersData.filteredData.length;
        this.usersData.paginator = this.paginator;
        this.isNoUser = false;
      }
    },
      (error) => {
        this.router.navigate(["/login"]);
      },
      () => {
      }) || undefined;
    this.userServiceSubscription$ = this.usersService.getusersLanding()?.subscribe(resData => {
      this.usersData = resData?.data;
      if (this.usersData?.length == 0) {
        this.isNoUser = true;
      }
      else {
        this.usersData = new MatTableDataSource(this.usersData);
        this.userCount = this.usersData.filteredData.length;
        setTimeout(() => {
          this.usersData.paginator = this.paginator;

          if(this.usersData.paginator) {
            // ------Set translation for pagination------
            this.translate.stream([
              'users.pagination.pageLabel',
              'users.pagination.firstPage',
              'users.pagination.lastPage',
              'users.pagination.nextPage',
              'users.pagination.prevPage'
            ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                this.usersData.paginator._intl.itemsPerPageLabel = translation['users.pagination.pageLabel'];
                this.usersData.paginator._intl.firstPageLabel = translation['users.pagination.firstPage'];
                this.usersData.paginator._intl.lastPageLabel = translation['users.pagination.lastPage'];
                this.usersData.paginator._intl.nextPageLabel = translation['users.pagination.nextPage'];
                this.usersData.paginator._intl.previousPageLabel = translation['users.pagination.prevPage'];

                this.usersData.paginator._intl.changes.next();
            });
          }
        });
        this.isNoUser = false;
      }
    },
      (error) => {
        this.router.navigate(["/login"]);
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;
  }

  userFilter(): void {
    let isActive = null;
    if (this.userStatus == 'Active' || this.userStatus == 'Activa') {
      isActive = true;
    } else if (this.userStatus == 'Inactive' || this.userStatus == 'Inactiva') {
      isActive = false;
    } else {
      isActive = '';
    }

    const options = 'firstName=' + encodeURIComponent(this.firstName)
      + '&lastName=' + encodeURIComponent(this.lastName)
      + '&emailId=' + encodeURIComponent(this.emailId)
      + '&active=' + encodeURIComponent(isActive);

    this.userFilterServiceSubscription$ = this.usersService.UsersFilter(options)?.subscribe(
      (resData) => {
        this.usersData = resData?.data;
        if (this.usersData?.length == 0) {
          this.noDataFound = true;
        }
        this.usersData = new MatTableDataSource(this.usersData);
        this.userCount = this.usersData.filteredData.length;
        this.usersData.paginator = this.paginator;
      },
      (error) => {
        this.isNoUser = true;
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;
    this.noDataFound = false;

  }

  resetFilter() {
    this.firstName = "";
    this.lastName = ""
    this.emailId = "";
    this.userStatus = "";
    this.noDataFound = false;

    this.userServiceSubscription$ = this.usersService.getusersLanding()?.subscribe(resData => {
      this.usersData = resData?.data;
      if (this.usersData?.length < 0) {
        this.noDataFound = true;
      }
      else {
        this.usersData = new MatTableDataSource(this.usersData);
        this.userCount = this.usersData.filteredData.length;
        this.usersData.paginator = this.paginator;
      }
    },
      (error) => {
        this.router.navigate(["/login"]);
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;
  }

  openEditUserDialog(useruuid: number): void {
    // this.router.navigate(["userss", useruuid]);
    const dialogRef = this.dialog.open(UserEditComponent, {
      minWidth: '70%',
      maxWidth: '90vw',
      data: {
        useruuid: useruuid
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  openNewUserDialog(): void {
    let user = JSON.parse(sessionStorage.getItem('currentUser'));
    if(user.maxnumberofusers == this.userCount){
       this.dialog.open(UserNotifyComponent, {
        data: {
          message: this.translate.instant('users.userExceedMsg'),
        },
        width: '500px'
      });
    } else {
      const dialogConfig: MatDialogConfig<UserCreateComponent> = {
        minWidth: '950px',
        maxWidth: '50vw'
      };
      const dialogRef = this.dialog.open(UserCreateComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  ngOnDestroy() {
    if (this.userServiceSubscription$) {
      this.userServiceSubscription$.unsubscribe();
    }
    if (this.userFilterServiceSubscription$) {
      this.userFilterServiceSubscription$.unsubscribe();
    }

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
